import React, {ReactNode} from 'react';

import Button from 'shared/ui/Button/Button/Button';

import styles from './HeaderEmail.module.scss';

interface HeaderEmailProps {
    title: string;
    children: ReactNode;
    buttonText: string | undefined;
    onClick?: () => void;
    icon: string;
    button?: boolean,
}

const HeaderEmail: React.FC<HeaderEmailProps> = ({title, children, buttonText, onClick, icon, button}) => {
    return (
        <div className={styles.content}>
            <h2 className={styles.title}>{title}</h2>
            <span className={styles.text}>{children}</span>
            <img className={styles.img} src={icon} width={300} height={300} alt={'email'}/>
            {button && (
                <Button
                    variant="gradient"
                    onClick={onClick}
                    className={styles.button}
                >
                    {buttonText}
                </Button>
            )}
        </div>
    );
};

export default HeaderEmail;